import { React, useState } from "react";
import { TableContainer, Tags, Labels } from "../customersPage.styled";
import { MenuItem, Select } from "@mui/material";
import { TableButton } from "../../../components/DataTable/DataTable.styles";
import MessageUser from "../../../assets/icons/MessageUser.svg";
import DeleteIcon from "../../../assets/icons/deleteIcon.svg";
import Tooltip from "@mui/material/Tooltip";
import ConfirmModal from "../../../components/ConfirmModal";
import { handleCustomerDeletion } from "../customersUtils";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { Backdrop, CircularProgress } from "@mui/material";
                              // eslint-disable-next-line react/prop-types
function TableHeader({ dateFilter, handleDateFilterChange, selected, customerData, userFilter, handleUserFilter}) {
	const [confirmModal, setConfirmModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const deleteMultipleCustomers = async() => {
		setLoading(true)
		if (selected.length > 0) {
			setConfirmModal(false);
			const selectedIds = selected.map((customer) => {
				return customer.objectId;
			});
			let data = await handleCustomerDeletion(selectedIds);
			try {
				if (data.result) {
					setLoading(false)
					toast.success("customer deleted successfully");
					customerData(); //delete and call updated table list
				} else {
					setLoading(false)
					toast.error("unable to delete customer, please try again later");
				}
			} catch (error) {
				setLoading(false)
				toast.error("unable to delete customer, please try again later");
			}
		} else {
			setLoading(false)
			toast.error("customer(s) not found");
			return;
		}
	};
	return (
		<TableContainer>
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: "Delete Customer(s)",
						desc: "Are you sure you want to Delete these customer(s)?",
						btnText: "Yes, Delete",
					}}
					handleDeleteAction={deleteMultipleCustomers}
				/>
			)}

			<header>
				<section className='section'>
					<Tags>
						<Labels type='Personal' />
						<p>Personal Profile</p>
					</Tags>

					<Tags>
						<Labels type='Business' />
						<p>Business Profile</p>
					</Tags>

					<Tags>
						<Labels type='Investor' />
						<p>Investor Profile</p>
					</Tags>
				</section>

				<main>
					<Select
						value={dateFilter}
						className='toolbarSelect'
						onChange={(e) => handleDateFilterChange(e)}
					>
						<MenuItem value='Today'>Today</MenuItem>
						<MenuItem value='Week'>Last 7 days</MenuItem>
						<MenuItem value='Month'>Last 30 days</MenuItem>
						<MenuItem value='6 Months'>Last 6 months</MenuItem>
						<MenuItem value='Year'>Last 12 months</MenuItem>
						<MenuItem value='All'>All Time</MenuItem>
					</Select>

					<Select
						value={userFilter}
						className='toolbarSelect'
						onChange={(e) => handleUserFilter(e)}
					>
						<MenuItem value='Investor'>Investor</MenuItem>
						<MenuItem value='Personal'>Personal</MenuItem>
						<MenuItem value='Business'>Business</MenuItem>
						<MenuItem value='All'>All Users</MenuItem>
					</Select>
					<Tooltip title='Message' arrow>
					<TableButton>
                    <img className='' src={MessageUser} />
                </TableButton>
				</Tooltip>
					<Tooltip title='Delete' arrow>
						<TableButton
							onClick={() => {
								setConfirmModal(true);
							}}
						>
							<img className='' src={DeleteIcon} />
						</TableButton>
					</Tooltip>
				</main>
			</header>
			{loading && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={loading}
				>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</TableContainer>
	);
}
TableHeader.propTypes = {
	selected: PropTypes.array,
	handleDateFilterChange:  PropTypes.func,
	customerData: PropTypes.func,
};

export default TableHeader;
